import BaseService from "@/shared/base.service";

import { useAlertStore } from "@/stores/alert.store";

import type { Query } from "@/types/model/query";
import type { QueryParams } from "@/types/request/getQuery";
import type { QueryResponse } from "@/types/response/query";
import type { QueryExecutionResponse } from "@/types/response/queryExecution";

export class QueryService {
  static async GetAllQueries(
    payload: QueryParams
  ): Promise<QueryResponse | null> {
    try {
      const params = { ...payload };

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.get<QueryResponse>(
        `queries`,
        queryParams
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in GetAllQueries:", error);
      return null;
    }
  }

  static async GetQueryById(
    query_id: string
  ): Promise<QueryResponse | null> {
    try {
      const params = {
        query_id,
      };

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.get<QueryResponse>(
        `queries`,
        queryParams
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in GetQueryById:", error);
      return null;
    }
  }

  static async CreateQuery(payload: object): Promise<Query | null> {
    try {
      const response = await BaseService.post<Query>(
        `queries`,
        payload
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in CreateQuery:", error);
      return null;
    }
  }

  static async UpdateQuery(payload: object): Promise<Query | null> {
    try {
      const params = {
        ...payload
      }

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.put<Query>(
        `queries`,
        queryParams
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in UpdateQuery:", error);
      return null;
    }
  }

  static async DeleteQuery(
    query_id: string
  ): Promise<Query | null> {
    try {
      const response = await BaseService.delete<Query>(
        `queries?query_id=${query_id}`
      );

      if (response) {
        useAlertStore().show("warning", "Query removida com sucesso.");
      }

      return response ?? null;
    } catch (error) {
      console.error("Error in DeleteQuery:", error);
      return null;
    }
  }

  static async ExecuteQuery(
    query_id: string,
    use_cache = false,
    timeout = 300
  ): Promise<QueryExecutionResponse | null> {
    try {
      const params = {
        query_id,
        use_cache: use_cache.toString(),
        timeout: timeout.toString(),
      };

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.get<QueryExecutionResponse>(
        `queries/execute`,
        queryParams
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in ExecuteQuery:", error);
      throw error;
    }
  }
}
